export let global = {
    "token": ""
}